import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Cradle } from '@solo/app-core';
import { toast } from 'react-toastify';
import Icons from '@/app/ui/molecules/Icons';
import { useCradle } from '@/app/contexts';
import { translate } from '@/app/i18n';

const LoginGoogleMiddlewarePage = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { authBloc } = useCradle<Cradle>();

  useEffect(() => {
    async function getUserFromGoogleURL() {
      const code = searchParams.get('code');
      if (!code) return;
      try {
        await authBloc.loginWithGoogleAuthCode(code);
        // TODO redirect to complete register if alice / signaturit verification is missing
        navigate('/dashboard');
      } catch (error) {
        toast.error(translate('TOAST.LOGIN_ERROR'));
      }
    }
    getUserFromGoogleURL();
  }, [searchParams]);

  return <Icons.Spinner />;
};
export default LoginGoogleMiddlewarePage;
